let currentActiveTag = "all";

export function getActiveTag() {
    return currentActiveTag;
}

export function setActiveTag(tag) {
    currentActiveTag = tag;
}

export function matchesTag(card, tag) {
    if (!card) return false;
    if (!tag || tag === "all") return true;
    const normalizedTag = tag.toLowerCase().trim();
    const rawTags = (card.getAttribute("data-tags") || "").toLowerCase();
    const tagList = rawTags.split(/\s+/).filter(Boolean);
    if (tagList.includes(normalizedTag)) return true;
    if (card.classList.contains(`tag-${normalizedTag}`)) return true;
    return false;
}
